import { motion } from "framer-motion";
import React from "react";
import "./AboutScreen.css";
import Navbar from "./Navbar";
import ProgressBar from "./ProgressBar";
import Profile from "./images/profile.png";

function AboutScreen() {
	const pageVariants = {
		initial: {
			opacity: 0,
			x: "-100vw",
		},
		in: {
			opacity: 1,
			x: 0,
		},
		out: {
			opacity: 0,
			x: "100vw",
		},
	};
	const pageTransition = {
		type: "spring",
		stiffness: 55,
		duration: 0.2,
	};
	return (
		<div className="aboutScreen">
			<Navbar />
			<motion.div
				className="aboutScreen__body"
				initial="out"
				animate="in"
				exit="out"
				variants={pageVariants}
				transition={pageTransition}
			>
				<div className="aboutScreen__left">
					<img className="profile__image" src={Profile} alt="" />
				</div>
				<div className="aboutScreen__right">
					<div className="aboutScreen__topleft">
						<strong className="info">
							<span>H</span>ello World! I'm Hitesh Sharma web developer and web
							designer, focused on crafting clean & user-friendly experiences.
							I'm passionate about excellent software that improves the lives of
							those around me.
						</strong>
					</div>
					<div className="aboutScreen__bottomright">
						<strong className="skills__info">Skills</strong>
						<div className="skills__container">
							<ProgressBar title="html" percent={90} />
							<ProgressBar title="css" percent={85} />
							<ProgressBar title="javascript" percent={70} />
						</div>
					</div>
				</div>
			</motion.div>
		</div>
	);
}

export default AboutScreen;
